import { render, staticRenderFns } from "./CategorySectionComponent.vue?vue&type=template&id=5433826e"
import script from "./CategorySectionComponent.vue?vue&type=script&lang=js"
export * from "./CategorySectionComponent.vue?vue&type=script&lang=js"
import style0 from "./CategorySectionComponent.vue?vue&type=style&index=0&id=5433826e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports